import { Badge } from '@chakra-ui/react';

export function BetaBadge(props) {
    return (
        <Badge colorPalette="primary" variant="subtle" size="xs" textTransform="uppercase" letterSpacing="wide" {...props}>
            Beta
        </Badge>
    )
}
